
export async function createFiscalData(fiscalDataRepository, fiscalData) {
  return fiscalDataRepository.save(fiscalData)
}

